/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
     <br><br>
  <div>
  <div class="formPosition">

            <v-card style="margin:auto;" width="900px">

              <template >

                  <v-toolbar color="grey lighten-2">

             <v-row>
                    <v-col sm="4" cols="12" md="4">

<v-btn v-if="novo"  color="primary" size="10" fab   @click="novo= false"><v-icon large   >clear</v-icon></v-btn>
<v-btn v-if="!novo"  color="primary" size="10" fab   @click="editar()"><v-icon large   >edit</v-icon></v-btn>

    </v-col>

     <v-col sm="4" cols="12" md="6">  <!--  form titlte section   {{ formTitle }}-->
  <span> Cadastro de contas</span>

     </v-col>

      <v-col sm="4"  cols="12" md="2">
        <v-btn size="18"    fab dark color="success"  @click="novo=true">
              <v-icon dark>add</v-icon>
            </v-btn>
    </v-col>

  </v-row>

                  </v-toolbar>

              </template>

 <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >

              <v-card-text>

                <v-container  >

<div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

                  <v-row>
                    <v-col  cols="12" md="12">
                      <v-text-field
                        :rules="ruleTextRequired"
                        v-model="servico"
                        label="Insira o serviço"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                   <v-row>
   <v-col md="4"></v-col>
   <v-col md="4"></v-col>
  <v-col md="2"><!--<v-btn fab   color="success"      @click="close"><v-icon large >edit</v-icon></v-btn>-->
  </v-col>
   <v-col md="2">
      <v-btn    :disabled="!valid && novo"  fab        color="success"    @click="save"><v-icon large   >send</v-icon></v-btn>

   </v-col>
 </v-row>
                </v-container>
              </v-card-text>

</v-form>

            </v-card>

  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    datebi: null,
    date: null,
    novo: false,
    progresso: false,
    descricao: 'Nº do Bi',
    valid: true,
    menu: false,
    menubi: false,
    ano_actual: ls.get('anolectivo'),
    habilitaBi: false,
    startDate: null,
    cursos: [],
    isLoading: false,
    turmasAll: [],
    servico: '',
    mascara: '#########-AA-###',
    turmasFiltered: [],
    municipiosAll: [],
    cor: '',
    municipiosFiltered: [],
    provincias: [],

    searchInDb: '',
    estudantes: [],
    servicos: [],
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Nome do Serviço',
        align: 'left',
        sortable: false,
        value: 'servico'
      },

      { text: 'Autor', value: 'autor' },
      { text: 'data cadastro', value: 'data_' }
    ],

    msg: '',
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    editedItem: {

      pkPessoa: 0,
      bi: null,
      idPessoa: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: null,
      // eslint-disable-next-line no-dupe-keys
      bi: null,
      ResidenteEm: 1,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null
    },
    defaultItem: {
      pkPessoa: 0,
      idPessoa: '',
      bi: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: '',
      // eslint-disable-next-line no-dupe-keys
      bi: '',
      ResidenteEm: '',
      instituicao: '',
      instituicaodescricao: '',
      curso: null,
      turma: null
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select

  },

  methods: {
    async initialize (searchInDb) {
      try {
        //   let  payload =""
        if (!searchInDb) {
          var payload = '{"anoacademico":"' + this.$store.state.idclasse + '","find":"all"}'
        } else {
          // eslint-disable-next-line no-redeclare
          var payload = '{"anoacademico":"' + this.$store.state.idclasse + '","find":"' + searchInDb + '"}'
        }

        this.isLoading = true
        this.estudantes = await axios
          .get('/estudanteFindAll/' + payload)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // combo qua depende de outra combo
    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL
    outroDoc () {
      if (this.descricao === 'Outro Doc.') {
        this.editedItem.bi = ''
        this.descricao = 'Nº do Bi'
        this.mascara = '#########-AA-###'
        this.ruleBI =
        [
          value => value.length === 16 || 'Minimo de caracteres exigido( 16 )'
        ]
      } else {
        this.editedItem.bi = ''
        this.descricao = 'Outro Doc.'
        this.mascara = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
        this.ruleBI =
        [
          value => value.length >= 16 && value.length <= 30 || 'Minimo de caracteres exigido( 16 )'
        ]
      }
    },

    loadTurmaComb (curso) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === curso.idCurso)
      this.$nextTick(() => { this.editedItem.turma = undefined })
    },

    chamaDialogo () {
      this.dialog = true
    },

    loadMunicipioComb (provincia) {
      this.$nextTick(() => { this.municSelectedForComb = undefined })
      // eslint-disable-next-line no-return-assign
      return this.municipiosFiltered = this.municipiosAll.filter(municipio => municipio.idProvincia === provincia.idProvincia)
    },
    async initializeMunicipiosAll () {
      try {
        this.isLoading = true
        this.municipiosAll = await axios
          .get('/municipioFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async initializeProvincias () {
      try {
        this.isLoading = true
        this.provincias = await axios
          .get('/provinciaFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
        console.log(this.$store.state.actividades)
      } catch (error) {

      }
    },

    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
        console.log(this.cursos)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeturmasAll () {
    //  turmaFindWithEstudanteCount

      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll/' + this.idclasse)
          .then(res => res.data)
        this.isLoading = false
        console.log(this.turmasFiltered)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    editItem (item) {
      this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)

      // let v=  Object.assign({},  this.municipios[5]);
      try {
        // prara trazer valores default na combo
        // procura na collecao ja carregada
        this.municSelectedForComb = this.municipiosAll.filter(mun => mun.idMunicipio === item.idMunicipio)
        // seta o valor encontrado
        this.municSelectedForComb = this.municSelectedForComb[0]

        this.proviSelectedForComb = this.provincias.filter(
          prov => prov.idProvincia === this.municSelectedForComb.idProvincia
        )

        this.proviSelectedForComb = this.proviSelectedForComb[0]
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }

      this.dialog = true
    },

    deleteItem (item) {
      const index = this.estudantes.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.delete(item.pkPessoa)
      // this.estudantes.splice(index, 1)
    },

    close () {
      this.dialog = false
      this.$refs.form.reset()
    },
    saveDate (date) {
      this.$refs.menu.save(date)
      this.editedItem.datanascimento = date

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },
    saveDatebi (datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataemissaobi = datebi

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(date).toISOString().substr(0, 10)
    },
    async save () {
      if (this.$refs.form.validate()) {
        this.progresso = true
        let params =
          {
            pk_outros_servicos: 0,
            servico: this.servico
          }

        let params_tabela =
          {
            servico: params.servico,
            autor: ls.get('nomeUsuario'),
            data_: new Date()
          }

        try {
          let cor_mensagem = 'msgError'
          let msg = await axios
            .post('/servicosInsertOrUpdate', params)
            .then(res => res.data)

          if (msg.length) {
            cor_mensagem = 'msgError'
            this.text = 'Ocorreu um erro ao tentar efectuar a operação'
          } else {
            cor_mensagem = 'msgSuccess'
            this.text = 'Inserção efectuada com sucesso'
            this.servicos.unshift(params_tabela)
          }

          this.dialog = false
          this.progresso = false
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': cor_mensagem, 'timeout': 8000 })
        } catch (error) {
          console.log('eroooo: ' + error)
          this.text = error.message
        }
      }
    },

    Limpar () {
      this.editedItem.nome = ''
      this.editedItem.bi = ''
      this.editedItem.datanascimento = ''
      this.editedItem.nomedopai = ''
      this.editedItem.nomedamae = ''
      this.editedItem.dataemissaobi = ''
      this.editedItem.telefone = ''
    },

    async delete (idv) {
      try {
        var msg = await axios
          .get('/estudanteDeleteById/' + idv)
          .then(res => res.data)
        this.text = 'Deleted ' + msg.message

        this.initialize()

        this.close()
      } catch (error) {
        console.log('eroooo: ' + error)
        this.text = error.message
      } finally {

      }
    }
  }
}
</script>
<style scoped>

.bg {
 color:green;
 background: red
}

</style>
